import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";
import Typography from "../../components/Helpers/Typography";
import CenterWidget from "../../components/Layout/CenterWidget";
import buildAssetsUrl from "../../util/strings/buildAssetsUrl";

// styling
const containerStyles = () => ({
  sp_text: {
    display: "flex",
    alignItems: "center",
  },
  img: {
    // this should probably change
    // not sure how we're going to be displaying logos yet
    height: "108px",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    paddingBottom: 44,
  },
  sp_logo: {
    display: "block",
    minHeight: 28,
    marginLeft: 10,
  },
});

export const LoginLogo = props => {
  const { classes, url } = props;

  return (
    <CenterWidget
      footer={
        <Typography className={classes.sp_text} component="div">
          <div>Powered by</div>
          <img
            className={classes.sp_logo}
            src={buildAssetsUrl("sp-sign-in-logo.svg")}
            alt="superpedestrian logo"
          />
        </Typography>
      }
    >
      <img className={classes.img} src={url} alt="logo" />
    </CenterWidget>
  );
};

LoginLogo.propTypes = {
  classes: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired,
};

export default withStyles(containerStyles)(LoginLogo);
